"use strict";

var _useAccountSuppliersMetaSupplierQuery;
import { useMemo } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay/hooks';
import { useSupplierMeta } from './useSupplierMeta';
export const useAccountSuppliersMeta = ({
  supplierId
}) => {
  const {
    supplier: viewerSupplierMetaRef
  } = useLazyLoadQuery(_useAccountSuppliersMetaSupplierQuery !== void 0 ? _useAccountSuppliersMetaSupplierQuery : _useAccountSuppliersMetaSupplierQuery = require("../../relay/__generated__/useAccountSuppliersMetaSupplierQuery.graphql"), {
    supplierId
  }, {
    fetchPolicy: 'store-or-network'
  });
  const viewerSupplierMeta = useSupplierMeta({
    supplier: viewerSupplierMetaRef
  });
  return useMemo(() => ({
    viewerSupplierMeta
  }), [viewerSupplierMeta]);
};